export { CARReaderStream } from './reader.js'
export { CARWriterStream } from './writer.js'

/**
 * IPLD multicodec code for CAR.
 * @see https://github.com/multiformats/multicodec/blob/c954a787dc6a17d099653e5f90d26fbd177d2074/table.csv#L141
 */
export const code = 0x0202
